import React, { useContext } from "react"
import { Div } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faBoxArchive,
	faBoxOpen,
	faClipboardList,
	faUserPen,
} from "@fortawesome/free-solid-svg-icons"
import { motion } from "framer-motion"
import { theme } from "../settings/config"
import { modalContext } from "../providers/modal.provider"
import { isArchivedPlayer } from "../utils/func.utils"

// Un bottone della riga in fondo: icona arancione sopra, nome sotto, sul
// fondo caldo dei blocchi dentro la scheda bianca
function ActionButton({ icon, label, ariaLabel, onClick }) {
	return (
		<motion.div whileTap={{ scale: 0.95 }} style={{ display: "flex" }}>
			<Div
				tag="button"
				type="button"
				aria-label={ariaLabel}
				w="100%"
				h="3.625rem"
				d="flex"
				flexDir="column"
				align="center"
				justify="center"
				rounded="15px"
				border="0"
				bg={theme.colors.background}
				textColor={theme.colors.gunmetal}
				textWeight="600"
				textSize="caption"
				cursor="pointer"
				style={{ gap: "0.25rem", font: "inherit", fontSize: "0.8125rem" }}
				onClick={onClick}>
				<FontAwesomeIcon icon={icon} color={theme.colors.primary} style={{ height: "1rem" }} />
				{label}
			</Div>
		</motion.div>
	)
}

// Le azioni sull'allievo aperto, tutte in fondo e tutte uguali: la scheda
// tecnica (da scrivere o da cambiare: si apre lo stesso foglio), il nome e
// l'archivio. Un allievo archiviato la scheda la tiene, ma non la si
// scrive più: si riattiva prima.
function PlayerActions({ playerData }) {
	const Modal = useContext(modalContext)
	const isArchived = isArchivedPlayer(playerData)

	const actions = [
		!isArchived && {
			key: "sheet",
			icon: faClipboardList,
			label: "Scheda",
			ariaLabel: "Scheda tecnica",
			onClick: () => Modal.open("technicalSheet", playerData),
		},
		{
			key: "rename",
			icon: faUserPen,
			label: "Rinomina",
			onClick: () => Modal.open("editPlayer", playerData),
		},
		{
			key: "archive",
			icon: isArchived ? faBoxOpen : faBoxArchive,
			label: isArchived ? "Riattiva" : "Archivia",
			onClick: () => Modal.open("archivePlayer", playerData),
		},
	].filter(Boolean)

	return (
		<Div
			m={{ t: "0.5rem", x: "0.5rem", b: "0.75rem" }}
			style={{
				display: "grid",
				gridTemplateColumns: `repeat(${actions.length}, minmax(0, 1fr))`,
				gap: "0.5rem",
			}}>
			{actions.map(({ key, ...action }) => (
				<ActionButton key={key} {...action} />
			))}
		</Div>
	)
}

export default PlayerActions
